export default __webpack_public_path__ + "static/Citronal-22471c1ee48cb5ac05b6ac980076228b.png";